import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { GlobalStoreStateType } from "@/state/@types";
import { reconcileOpenThreadTabs } from "@/state/threadTabs";
import { createThreadSlice } from "@/state/slices/thread.slice";
import { createCommandCenterSlice } from "@/state/slices/commandCenter.slice";
import { createCoreSlice } from "@/state/slices/core.slice";
import { createDashboardSlice } from "@/state/slices/dashboard.slice";
import { createNavigationSlice } from "@/state/slices/navigation.slice";
import { createUtilityBarSlice } from "@/state/slices/utilityBar.slice";

const PERSISTED_CORE_KEYS = [
  "activeEntityIdentifiers",
  "activeThreadNodeId",
  "openThreadTabs",
  "entities",
  "isSidebarMinimized",
  "nodePanelSize",
  "isPageContextEnabled",
  "nodeDetailLayoutModes",
  "isTriageOneAtATime",
  "hiddenTriageRowParts",
  "isTriageMirrored",
  "reviewableDialogNodeIds",
  "scopedEntityIdentifier",
  "externalGrantIdentifiers",
  "timeSeriesFilter",
  "userIdentifier",
] as const;

export const useGlobalStore = create<GlobalStoreStateType>()(
  persist(
    (set, get, api) => ({
      ...createCoreSlice(set, get, api),
      ...createUtilityBarSlice(set, get, api),
      ...createCommandCenterSlice(set, get, api),
      ...createThreadSlice(set, get, api),
      ...createNavigationSlice(set, get, api),
      ...createDashboardSlice(set, get, api),
    }),
    {
      name: "global-store",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => {
        return PERSISTED_CORE_KEYS.reduce(
          (acc, key) => {
            acc[key] = state[key];
            return acc;
          },
          {} as Record<string, any>,
        );
      },
      merge: (persisted: any, current) => {
        const merged = { ...current, ...persisted };
        merged.openThreadTabs = reconcileOpenThreadTabs(
          merged.openThreadTabs,
          merged.activeThreadNodeId ?? null,
        );
        return merged;
      },
    },
  ),
);
